module.exports = __webpack_public_path__ + "img/product1.f39ec952.png";